module.exports = __webpack_public_path__ + "img/046-lion.2d6fe193.svg";